var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Stream from "./Stream";
import VideoDeviceSelect from "./VideoDeviceSelect";
import AudioDeviceSelect from "./AudioDeviceSelect";
import OptionsMenuSelect from "./OptionsMenuSelect";
export default {
    name: "local",
    components: {
        Stream: Stream,
        VideoDeviceSelect: VideoDeviceSelect,
        AudioDeviceSelect: AudioDeviceSelect,
        OptionsMenuSelect: OptionsMenuSelect,
    },
    data: function () {
        return {
            localPeerId: "",
            dropdownVisible: false,
        };
    },
    computed: {
        sourceStream: function () {
            return this.$store.getters.localStream;
        },
    },
    methods: {
        toggleDropdown: function () {
            this.dropdownVisible = !this.dropdownVisible;
        },
    },
    mounted: function () {
        this.$nextTick(function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.$store.dispatch("loadInputDevices")
                            // Listen for device changes only after first initialization          
                        ];
                        case 1:
                            _a.sent();
                            // Listen for device changes only after first initialization          
                            navigator.mediaDevices.addEventListener("devicechange", function () {
                                _this.$store.dispatch("loadInputDevices");
                            });
                            return [2 /*return*/];
                    }
                });
            });
        });
    },
    created: function () {
        var _this = this;
        this.$socket.whenReady().then(function (_a) {
            var session = _a.session;
            _this.localPeerId = session.peerGuid;
        });
        document.addEventListener("click", function (event) {
            if (event.target.matches("[data-settings-dropdown]"))
                return;
            _this.dropdownVisible = false;
        });
    },
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/MyStream.vue
// module id = 329
// module chunks = 1